import { isNil, map } from 'lodash-es';
import { api } from '../commonApi';
import { IGetOrderResponse } from '../../proto/order/order';
import { IUpdateOrderItemStatusRequest } from '../../proto/order/orderItem';
import { EOrderItemStatus } from '../../proto/order/orderItemStatus.enum';

const BASE_ORDER_URL = `/order`;

export const orderApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getOrders: builder.query<IGetOrderResponse[], { statuses: EOrderItemStatus[] }>({
			query: ({ statuses }) => {
				const params = new URLSearchParams({
					status: statuses.join(','),
				});

				return `${BASE_ORDER_URL}?${params.toString()}`;
			},
			providesTags: (result) => {
				return [{ type: `Order`, id: 'LIST' }, ...map(result, (order) => ({ type: 'Order', id: order.id }))];
			},
		}),
		gerOrderById: builder.query<IGetOrderResponse, { orderId: string }>({
			query: ({ orderId }) => {
				return `${BASE_ORDER_URL}/${orderId}`;
			},
			providesTags: (result, error, { orderId }) => {
				const tags = [{ type: `Order`, id: orderId }];

				if (!isNil(result?.tableSession?.id)) {
					tags.push({ type: 'Order - TABLE_SESSION', id: result.tableSession.id });
				}

				return tags;
			},
		}),
		updateOrderItemStatus: builder.mutation<void, { orderItemId: string } & IUpdateOrderItemStatusRequest>({
			query: ({ orderItemId, ...body }) => ({
				url: `${BASE_ORDER_URL}/updateOrderItemStatus/${orderItemId}`,
				method: 'PUT',
				body,
			}),
			invalidatesTags: () => {
				// In a real-world scenario, we would fetch the orderId from the response or have it passed in the arguments.
				// Here, we assume that the itemId is unique enough to find the related order.
				// This is a simplification and may not be accurate in all cases.
				return [{ type: 'Order', id: 'LIST' }]; // Invalidate all orders for simplicity
			},
		}),
	}),
});

export const { useGetOrdersQuery, useGerOrderByIdQuery, useUpdateOrderItemStatusMutation } = orderApi;
